<template>
  <a-input-password
    v-model:value="innerValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :size="size"
    :visibility-toggle="visibilityToggle"
    :maxlength="maxlength"
    :status="status"
    class="ant-password-input"
    @blur="onBlur"
    @pressEnter="onPressEnter"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  visibilityToggle?: boolean;
  maxlength?: number;
  status?: "" | "error" | "warning";
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  placeholder: "Nhập mật khẩu",
  disabled: false,
  size: "middle",
  visibilityToggle: true,
  maxlength: undefined,
  status: "",
});

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
  (e: "blur", event: FocusEvent): void;
  (e: "pressEnter", event: KeyboardEvent): void;
  (e: "change", value: string): void;
}>();

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onBlur = (e: FocusEvent) => emit("blur", e);
const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);
</script>

<!--
  Hướng dẫn sử dụng — Password
  Global: <h-password v-model="password" />
  Import: import { PasswordInput } from '@/components/ant/input'

  Props: modelValue, placeholder, disabled, size, visibilityToggle, maxlength, status
  Events: update:modelValue, change, blur, pressEnter
  Docs: src/components/ant/input/README.md
-->
